import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@/App.css";
import "leaflet/dist/leaflet.css";
import "sonner/dist/styles.css";
import { Toaster } from "sonner";

import { LandingPage } from "@/components/landing/LandingPage";
import { CoverageMapPage } from "@/components/coverage/CoverageMapPage";
import { AdminCoveragePage } from "@/components/coverage/AdminCoveragePage";

const twinLogo = "/assets/logo/twin-tc-logo-transparent.png";

const ClientPortalPlaceholder = () => {
  return (
    <main className="min-h-screen bg-background text-foreground px-6 py-20">
      <div className="mx-auto max-w-3xl rounded-2xl border border-white/10 bg-card/95 p-10 shadow-[0_20px_80px_rgba(0,0,0,0.45)]">
        <img src={twinLogo} alt="TWIN TC logo" className="brand-logo logo-glow mb-6 h-14 w-auto object-contain" />
        <h1 className="mb-4 text-3xl font-bold">Client Portal</h1>
        <p className="leading-8 text-foreground/80">
          This route is reserved for the upcoming client portal experience. You can update
          this destination anytime from <code className="text-primary">siteConfig.js</code>.
        </p>
      </div>
    </main>
  );
};

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/coverage-map" element={<CoverageMapPage />} />
          <Route path="/admin/coverage" element={<AdminCoveragePage />} />
          <Route path="/client-portal" element={<ClientPortalPlaceholder />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            background: "rgba(12, 16, 32, 0.96)",
            color: "#eaf0f8",
            border: "1px solid rgba(255, 255, 255, 0.14)",
          },
        }}
      />
    </div>
  );
}

export default App;
